"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evalPayloadToFormDataHandler = evalPayloadToFormDataHandler;
function evalPayloadToFormDataHandler(data) {
    return {
        visitDate: data.form.visitDate,
        physicianName: data.form.physicianName || "N/A",
        contactPerson: data.form.personSpokenAtDoctorOffice || "N/A",
        phoneNumberWithCountryCode: {
            countryCode: data.form.countryCode || "",
            phoneNumber: +(data.form.phoneNumber || 0),
        },
        nextDoctorVisit: data.form.nextDoctorVisitDate,
        clinicianAppointment: {
            visitDate: data.form.nextVisitDate,
            visitStartTime: data.form.nextVisitStartTime,
            visitEndTime: data.form.nextVisitEndTime,
        },
        frequency: data.form.frequency || "",
        notes: data.form.notes || "",
    };
}
